export enum TaskStatus {
    OnTime = "ON_TIME",
    Delayed = "DELAYED",
}
